import React, { createContext, useState, useEffect } from "react"
import { db } from "../../../helpers/firebase_helper"
import moment from "moment/moment"

export const JobContext = createContext()

/**
 * This is the provider that is used to wrap the Order list container to access the context in OrderList.jsx
 * @param {Object} children
 * @returns {Object}
 */
export const JobContextProvider = ({ children }) => {
  const [orderDetails, setOrderDetails] = useState([""])
  const [orderDate, setOrderDate] = useState()
  const [customerRating, setCustomerRating] = useState()
  const [serviceProviderRating, setServiceProviderRating] = useState()
  const [customerDetails, setCustomerDetals] = useState()
  const [orderStatus, setOrderStatus] = useState("")
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [serviceProviderDetails, setServiceProviderDetails] = useState()

  const getOrderDetails = async docId => {
    getRatingDetails(docId)
    const snapshot = await db.collection("orders").doc(docId).get()
    setOrderDetails(snapshot.data())
    console.log(
      moment(snapshot.data().updatedAt)
        .utcOffset("+05:30")
        .format("h:mm:ss a, DD/MM/YYYY")
    )
    setOrderStatus(snapshot?.data()?.status)
    try {
      const userDetailsSnapshot = await db
        .collection("users")
        .doc(snapshot.data().userId)
        .get()
      const customerOrderAddressSnapshot = await db
        .collection("users")
        .doc(snapshot.data().userId)
        .collection("addresses")
        .doc(snapshot.data().addressId)
        .get()
      setCustomerDetals({
        ...userDetailsSnapshot.data(),
        serviceAddress: customerOrderAddressSnapshot.data(),
      })
    } catch (e) {}
  }

  const getRatingDetails = async docId => {
    try {
      const currentOrderSnapshot = await db
        .collection("orders")
        .doc(docId)
        .get()
      const serviceProviderId = currentOrderSnapshot.data().serviceProviderId

      const servicePartnerDetails = await db
        .collection("users")
        .doc(serviceProviderId)
        .get()
      setServiceProviderDetails(servicePartnerDetails.data())
    } catch (e) {}

    try {
      const customerRatingSnapshot = await db
        .collection("orders")
        .doc(docId)
        .collection("rating")
        .doc("customer")
        .get()
      setCustomerRating(customerRatingSnapshot.data())
    } catch (e) {}

    try {
      const serviceProviderRatingSnapshot = await db
        .collection("orders")
        .doc(docId)
        .collection("rating")
        .doc("serviceProvider")
        .get()
      setServiceProviderRating(serviceProviderRatingSnapshot.data())
    } catch (e) {}
  }

  /**
   * This function edits the order Details
   */
  const editOderDetails = async (
    orderId,
    customerReview,
    partnerReview,
    orderStatus
  ) => {
    const orderStatusData = { status: orderStatus }
    const customerRating = { rating: customerReview }
    const serviceProviderRating = { rating: partnerReview }

    await db.collection("orders").doc(orderId).set(orderStatusData, {
      merge: true,
    })

    await db
      .collection("orders")
      .doc(orderId)
      .collection("rating")
      .doc("customer")
      .set(customerRating, {
        merge: true,
      })

    await db
      .collection("orders")
      .doc(orderId)
      .collection("rating")
      .doc("serviceProvider")
      .set(serviceProviderRating, {
        merge: true,
      })
    setShowSuccessAlert(true)
  }

  const providerValue = {
    orderDetails,
    customerRating,
    serviceProviderRating,
    orderStatus,
    customerDetails,
    showSuccessAlert,
    serviceProviderDetails,
    orderDate,

    getOrderDetails,
    getRatingDetails,
    setOrderStatus,
    editOderDetails,
    setShowSuccessAlert,
  }

  return (
    <JobContext.Provider value={providerValue}>{children}</JobContext.Provider>
  )
}
